const fontWeight = {
  'font-weight-normal': 400,
  'font-weight-medium': 500,
  'font-weight-demi-bold': 600,
};

module.exports = fontWeight;
